import { render, staticRenderFns } from "./binomialMatch.vue?vue&type=template&id=2e719916&scoped=true&"
import script from "./binomialMatch.vue?vue&type=script&lang=js&"
export * from "./binomialMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e719916",
  null
  
)

export default component.exports